import { render, staticRenderFns } from "./RegistrationContainerAlt.vue?vue&type=template&id=4128a74f&scoped=true"
import script from "./RegistrationContainerAlt.vue?vue&type=script&lang=js"
export * from "./RegistrationContainerAlt.vue?vue&type=script&lang=js"
import style0 from "./RegistrationContainerAlt.vue?vue&type=style&index=0&id=4128a74f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128a74f",
  null
  
)

export default component.exports